import { useTranslation } from "react-i18next"
import { IconButton, Tooltip } from '@mui/material';
import { NotificationsActive, NotificationsOffOutlined } from '@mui/icons-material';
import { StyledBadge } from '../Utilities';
import { useNotificationPreference } from '../hooks/useNotificationPreference';

export default function Notifications({ invertColors }) {

    const { enabled, toggle, loading } = useNotificationPreference({ type: 'weather' })
    const { t } = useTranslation()

    const iconStyle = { mr: 1, transform: 'scale(0.9)' }

    return (
        <Tooltip
            title={`${t('notifications.notifications')} ${enabled ? t('notifications.on') : t('notifications.off')}`}
            placement="top"
            arrow
        >
            <span>
                <IconButton
                    color={invertColors ? "secondary" : "primary"}
                    onClick={toggle}
                    disabled={loading}
                    sx={{ 
                        p: 0,
                        mr: { xs: "20px", md: "4px" },
                        mb: "1px",
                        '&.Mui-disabled': { color: invertColors && "dimgrey" },
                    }}
                >
                    <StyledBadge
                        badgeContent={t('notifications.new').toUpperCase()}
                        size="small"
                        invertColors={invertColors}
                        loading={loading}
                    >
                        {enabled
                            ? <NotificationsActive sx={iconStyle} />
                            : <NotificationsOffOutlined sx={iconStyle} />
                        }
                    </StyledBadge>
                </IconButton>
            </span>
        </Tooltip>
    )
}